import './Assets/Styles/App.css';
import AppRouting from './Routing/AppRouting';
function App() {
  return (

    <>
      <AppRouting />
    </>
  );
}

export default App;
